import React from 'react';

export function SettingRow({ children }) {
  return (
    <div className='setting-row-holder row-wrapped'>
      <div className='setting-row'>{children}</div>
    </div>
  );
}
